module.exports = "/_next/static/chromiums/og-1200x630-products-b45dce54fb2ff28d3d8ac3734e7645e5.jpg";